import { render, staticRenderFns } from "./HardwareShop.vue?vue&type=template&id=5a32f4e2&scoped=true&"
import script from "./HardwareShop.vue?vue&type=script&lang=js&"
export * from "./HardwareShop.vue?vue&type=script&lang=js&"
import style0 from "./HardwareShop.vue?vue&type=style&index=0&id=5a32f4e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32f4e2",
  null
  
)

export default component.exports